import React, { Component } from 'react';
import { Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import ModalForm from './Modal';
import api from "../../../services/api";
import { getId, getToken } from "../../../services/auth";

class DataTable extends Component {

  constructor(props) {
    super(props);
        this.state = {  
            juridicas: [],
        };
}

  deleteItem = id => {

    Swal.fire({
      title: 'Você tem certeza?',
      text: 'Excluir o Cliente definitivamente?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, Exclua!',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        const token = getToken();
      api.delete(`juridica/${id}`, {
        headers: { token, id_logado: getId() },
      })
        .then(response => {
          if (response.data.success) {
            Swal.fire({
              title: 'Desativado!',
              text: 'Cliente foi desativado.',
              icon: 'success',
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.value) {
                window.location.reload();
              }
            })
          }
          
        })
        .catch(err => console.log(err))
      }
  })

  }

  enableDisable = (newjuridicas, status) => {

    Swal.fire({
      title: 'Você tem certeza?',
      text: `${status ? 'Ativo': 'Inativo'} o Cliente definitivamente?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        const token = getToken();
        const id_logado = getId();
      api.delete(`juridica/enable_disable/${newjuridicas.id}`, {
        headers: { token, id_logado, status },
      })
        .then(response => {
          if (response.data.success) {
            Swal.fire({
              title: `${status ? 'Ativo': 'Inativo'}.`,
              text: `Cliente foi ${status ? 'Ativo' : 'Inativo'}.`,
              icon: 'success',
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.value) {
                this.setState(prevState => {
                  const juridicas = [...prevState.juridicas];
                  const index = juridicas.findIndex(m => m.id === newjuridicas.id);
                  newjuridicas.status = status ? '1' : '0'
                  juridicas[index] = newjuridicas;
            
                  return { juridicas };
                });
              }
            })
          }
          
        })
        .catch(err => console.log(err))
      }
  })

  }

  render() {
    const datas = this.props.datas.map(juridicas => {
      return (
        <tr key={juridicas.id}>
          <th scope="row">{juridicas.razao_social}</th>
          <td>{juridicas.cnpj}</td>
          <td>{juridicas.inscricao_estadual} | {juridicas.inscricao_municipal}</td>
          <td>
            <div className="btn-group" role="group" aria-label="Basic example">
              <button className={`btn ${juridicas.status === '1'? 'btn-success':'btn-secondary'} btn-sm`}  onClick={() => this.enableDisable(juridicas, 1)}>Ativo</button>
              <button className={`btn ${juridicas.status === '0'? 'btn-danger':'btn-secondary'} btn-sm`} onClick={() => this.enableDisable(juridicas, 0)}>Inativo</button>
            </div>
          </td>
          <td>
          <div className="dropdown show acoes ">
              <Link className="btn btn-primary btn-sm dropdown-toggle" to="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="fa fa-cog"></i>
              </Link>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <Link to="#" className="dropdown-item" style={{display: 'inherit'}}>
                <ModalForm className="modal-lg" juridicas={juridicas} />
                </Link>
                <Link to="#" className="dropdown-item" style={{display: 'inherit', width: '155px'}}>
                  <div>
                    <p className="dropdown-item table-remove" style={{ marginRight: "10px" }} onClick={() => this.deleteItem(juridicas.id)}> Remover <i className="fa fa-trash-alt"></i></p>
                  </div>
                </Link>
              </div>
            </div>           
          </td>
        </tr>
      )
    })

    return (
      <Table className="table table-bordered mb-3">
        <thead>
          <tr>
            <th style={{width: "400px"}}>RAZÃO SOCIAL</th>
            <th>CNJP</th>
            <th>Estadual | Municipal</th>
            <th style={{width: "145px"}}>ATIVO</th>
            <th style={{width: "105px"}}>AÇÕES</th>
          </tr>
        </thead>
        <tbody>
          {datas}
        </tbody>
      </Table>
    )
  }
}

export default DataTable